import { atom } from 'jotai';

export interface LandxmlMergeTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  outputName: string;
}

export const landxmlMergeTrackingAtom = atom<LandxmlMergeTracker[]>([]);
